module.exports = __webpack_public_path__ + "static/23.1-cefd68749b9480d28d74f8f0caaabb3a.jpg";